import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      style: {"fill":"#31A3AE"},
      d: "M256,153.3c-56.6,0-102.7,46.1-102.7,102.7S199.4,358.7,256,358.7S358.7,312.6,358.7,256S312.6,153.3,256,153.3\n\tz M321,228.3l-70.7,70.7c-2.1,2.1-4.9,3.2-7.7,3.2c-2.8,0-5.6-1.1-7.7-3.2l-35.4-35.4c-4.3-4.3-4.3-11.1,0-15.4s11.1-4.3,15.4,0\n\tl27.7,27.7l63-63c4.3-4.3,11.1-4.3,15.4,0C325.3,217.2,325.3,224.1,321,228.3L321,228.3z"
    }, null, -1)
  ]))]))
}
export default { render: render }